{
  "name": "karve-freya",
  "version": "2611.03.0",
  "engines": {
    "node": ">=20.0.0 <21.0.0",
    "npm": ">=10.0.0"
  },
  "scripts": {
    "ng": "ng",
    "dev": "ng serve --proxy-config proxy.conf.js ",
    "start": "ng serve --proxy-config proxy.conf.js",
    "dev:hosts": "ng serve --proxy-config proxy.conf.js --host 0.0.0.0",
    "build:prod": "node --max_old_space_size=12000 node_modules/@angular/cli/bin/ng build -c=production",
    "build:dev": "node --max_old_space_size=12000 node_modules/@angular/cli/bin/ng build -c=dev",
    "build-fragment": "node src/schemaQuery.js",
    "test": "ng test",
    "test:ci": "ng test --browsers=ChromeHeadlessCI --watch=false",
    "lint": "ng lint",
    "knip": "knip --include files,dependencies,unlisted",
    "e2e": "ng e2e",
    "link:aegis": "npm link ../aegis",
    "unlink:aegis": "npm unlink @move-right/aegis && npm install @move-right/aegis",
    "codegen": "npm run build-fragment && graphql-codegen --config codegen.ts"
  },
  "config": {},
  "private": true,
  "dependencies": {
    "@angular-magic/ngx-gp-autocomplete": "^2.0.2",
    "@angular/animations": "^17.3.12",
    "@angular/cdk": "^17.3.4",
    "@angular/common": "^17.3.12",
    "@angular/compiler": "^17.3.12",
    "@angular/core": "^17.3.12",
    "@angular/forms": "^17.3.12",
    "@angular/platform-browser": "^17.3.12",
    "@angular/platform-browser-dynamic": "^17.3.12",
    "@angular/router": "^17.3.12",
    "@angular/service-worker": "^17.3.12",
    "@apollo/client": "^3.12.4",
    "@datadog/browser-logs": "^7.13.0",
    "@datadog/browser-rum": "^7.13.0",
    "@fullcalendar/angular": "6.1.20",
    "@fullcalendar/core": "6.1.20",
    "@fullcalendar/daygrid": "6.1.20",
    "@fullcalendar/interaction": "6.1.20",
    "@fullcalendar/resource": "6.1.20",
    "@fullcalendar/resource-timeline": "6.1.20",
    "@fullcalendar/timegrid": "6.1.20",
    "@googlemaps/js-api-loader": "^1.16.6",
    "@move-right/aegis": "0.1.47",
    "@ngrx/component-store": "^17.2.0",
    "@ngrx/effects": "^17.2.0",
    "@ngrx/operators": "^17.2.0",
    "@ngrx/router-store": "^17.2.0",
    "@ngrx/store": "^17.2.0",
    "@ngrx/store-devtools": "^17.2.0",
    "@stripe/stripe-js": "^1.21.1",
    "@types/pluralize": "^0.0.33",
    "@types/qrcode": "^1.5.6",
    "apollo-angular": "^8.0.0",
    "chart.js": "^4.4.2",
    "cronstrue": "^2.23.0",
    "crypto-hash": "^3.1.0",
    "dayjs": "^1.11.11",
    "graphql": "^15.0.0",
    "graphql-tag": "^2.12.7",
    "graphql-ws": "^5.14.0",
    "lodash": "^4.17.21",
    "marked": "^12.0.1",
    "minisearch": "^6.1.0",
    "ngx-markdown": "^17.2.0",
    "ngx-print": "^1.5.1",
    "ngx-quill": "^25.3.2",
    "node-fetch": "^2.7.0",
    "papaparse": "^5.3.2",
    "pdfjs-dist": "^5.4.530",
    "pluralize": "^8.0.0",
    "primeflex": "^2.0.0",
    "primeicons": "^7.0.0",
    "primeng": "~17.18.0",
    "print-js": "^1.6.0",
    "prismjs": "^1.29.0",
    "qrcode": "^1.5.4",
    "quickjs-emscripten": "^0.31.0",
    "quill": "^2.0.3",
    "quill-to-word": "^1.3.0",
    "rxjs": "~7.8.1",
    "subscriptions-transport-ws": "^0.9.19",
    "subsink": "^1.0.2",
    "sucrase": "^3.35.1",
    "text-security": "^3.2.1",
    "tslib": "^2.0.0",
    "url-join": "^5.0.0",
    "uuid": "^10.0.0",
    "zen-observable": "^0.8.0",
    "zone.js": "~0.14.4"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.11",
    "@angular-eslint/builder": "17.5.3",
    "@angular-eslint/eslint-plugin": "17.5.3",
    "@angular-eslint/eslint-plugin-template": "17.5.3",
    "@angular-eslint/schematics": "^17.3.0",
    "@angular-eslint/template-parser": "17.3.0",
    "@angular/cli": "^17.3.11",
    "@angular/compiler-cli": "^17.3.12",
    "@datadog/datadog-ci": "^2.3.2",
    "@graphql-codegen/cli": "^5.0.2",
    "@graphql-codegen/typed-document-node": "^5.0.6",
    "@graphql-codegen/typescript": "^4.0.6",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.0",
    "@graphql-codegen/typescript-operations": "^4.2.0",
    "@ngrx/eslint-plugin": "^17.2.0",
    "@testing-library/cypress": "^9.0.0",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~3.6.0",
    "@types/lodash": "^4.14.172",
    "@types/node": "^12.11.1",
    "@types/papaparse": "^5.3.2",
    "@types/uuid": "^10.0.0",
    "@typescript-eslint/eslint-plugin": "^8.62.0",
    "@typescript-eslint/parser": "^8.62.0",
    "eslint": "^8.57.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-prefer-arrow": "^1.2.3",
    "jasmine-core": "~3.6.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "knip": "^6.21.0",
    "protractor": "~7.0.0",
    "typescript": "~5.4.5"
  },
  "overrides": {
    "@graphql-tools/executor-graphql-ws": "^1.1.2",
    "postcss-selector-parser": "^6.0.16",
    "@datadog/datadog-ci": {
      "simple-git": "^3.36.0",
      "form-data": "^4.0.6",
      "js-yaml": "^3.15.2"
    }
  }
}
